<template>
  <div>
    <FITModal ref="modal" reference="modal" :title="$t('osm.contents.general.delete')" @click="onClickModal">
      <div slot="body">
        <span v-html="$t('osm.contents.general.deletePolicyConfirm', {policyNumber: clickedRow.policyNumber, policyRef: clickedRow.policyReference})"></span>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :alertSec="3" :variant="alertParams.variant"></FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{this.$t('osm.contents.giPolicy.giPolicyList')}}</h4></b-col>
          <b-col cols="auto" class="ml-auto">
            <b-btn v-if="permissionLevel < 3.5" @click="$router.push('/osm/gi/new')" variant="success">{{$t('osm.contents.general.create')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <b-row class=" mx-0 px-0">
          <!-- <b-col cols="auto">
          <FITButton v-bind="this.createBtn" @click="createAction('Create')"></FITButton>
        </b-col> -->
          <b-col cols="2">
            <FITSelect :width="8" v-model="policyType.value" :label="$t('osm.contents.giPolicy.policyType')" :options="policyTypeList" @input="getDataList"></FITSelect>
          </b-col>
          <b-col cols="2">
            <FITSelect v-model="policyStatus.value" :label="$t('osm.contents.giPolicy.policyStatus')" :options="policyStatusList" @input="getDataList"></FITSelect>
          </b-col>
          <b-col cols="2">
            <FITSelect v-model="workFlowStep.value" :label="$t('osm.contents.giPolicy.currentWorkflow')" :options="workflowStepList" @input="getDataList"></FITSelect>
          </b-col>
          <b-col cols="auto" class="ml-auto mr-0">
            <b-row class="mx-0">
              <FITSelect class="pr-4" v-model="rowsPerPage.value" :label="$t('general.pagination.perPage')" :options="rowsPerPage.options" @input="setPerPage(rowsPerPage.value)"></FITSelect>
              <FITPagination v-model="pagination.currentPage" :perPage="rowsPerPage.value" :totalRows="totalItems.total" @input="setCurrentPage(pagination.currentPage)"></FITPagination>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mx-0" align-v="center">
          <b-col cols="4">
            <div class="form-group">
              <FITTextInput :width="10" :label="$t('general.search')" class="py-0" v-model="$v.searchInput.value.$model" v-bind="searchInput" @input="setSearch(searchInput.value)"></FITTextInput>
            </div>
          </b-col>
        </b-row>
        <div class="row mx-0 py-2">
          <b-table striped hover no-local-sorting responsive :slots="slots" :items="dataList" :fields="fields" @sort-changed="onSortChanged" class="minTableHeight">
            <!-- Actions Column Slot -->
            <template slot="policyType" slot-scope="row">
              {{getTranslatedPolicyField('policyType',row.item.policyType)}}
            </template>
            <template slot="workFlowStep" slot-scope="row">
              {{getTranslatedPolicyField('workFlowStep',row.item.workFlowStep)}}
            </template>
            <template slot="policyStatus" slot-scope="row">
              {{getTranslatedPolicyField('policyStatus',row.item.policyStatus)}}
            </template>
            <template slot="policyOwnerName" slot-scope="row">
              <div>{{row.item.englishNameOwnerCustomer | isEmpty}}</div>
              <div>{{row.item.chineseNameOwnerCustomer}}</div>
            </template>
            <template slot="currentAgentName" slot-scope="row">
              <div>{{row.item.englishNameServiceAgent | isEmpty}}</div>
              <div>{{row.item.chineseNameServiceAgent}}</div>
            </template>
            <template slot="approveAgentName" slot-scope="row">
              <div>{{row.item.englishNameApproveAgent | isEmpty}}</div>
              <div>{{row.item.chineseNameApproveAgent}}</div>
            </template>
            <template slot="actions" slot-scope="row">
              <FITDropdown v-model="actions.value.action" variant="primary" :text="actions.label" :options="actions.options" @clicked="onClickDropdown($event,row.item)"></FITDropdown>
            </template>
          </b-table>
        </div>
        <!-- Container Footer -->
        <div class="row mx-0 py-2">
          <b-col cols="auto" class="mr-auto align-self-center">
            <span class="text-secondary">{{ total }}</span>
          </b-col>
          <b-col cols="auto">
            <FITPagination v-model="pagination.currentPage" :perPage="rowsPerPage.value" :totalRows="totalItems.total" @input="setCurrentPage(pagination.currentPage)"></FITPagination>
          </b-col>
        </div>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import _ from 'lodash'
import { FITAlert, FITCheckbox, FITTextInput, FITCheckboxGroup, FITRadio, FITTextarea, FITSelect, FITDatePicker, FITTimepicker, FITvSelect, FITModal } from '@/components'
import { FITButton, FITDropdown, FITPagination, FITFormGroup, FITTable, FITFormCard } from '@/components'
import { required, minLength, between } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'giPolicyList',
  components: {
    FITButton,
    FITDropdown,
    FITTextInput,
    FITSelect,
    FITPagination,
    FITFormGroup,
    FITTable,
    FITFormCard,
    FITButton,
    FITAlert,
    FITModal
  },
  created() {
    this.getOptions();
    this.getDataList();
  },
  mounted() {
    if (this.alertContent.length > 0) {
      Vue.set(this.alertParams, 'content', this.alertContent);
      if (this.alertVariant.length > 0) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
      this.$refs.alert.showAlert();
      window.scrollTo(0, 0);
    }
  },
  props: {
    alertContent: {
      type: String,
      default: ''
    },
    alertVariant: {
      type: String,
      default: 'success'
    }
  },
  validations: {
    searchInput: {
      value: {
        required,
        minLength: minLength(5)
      }
    },
  },
  computed: {

    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    total() {
      return `${this.$t('osm.contents.general.page')} ${this.pagination.currentPage} / ${this.$t('osm.contents.general.total')} ${this.totalItems.total} ${this.$t('osm.contents.general.items')}`;
    },
    ...mapGetters("GIPolicy", [
      'getTranslatedOptions'
    ]),
    policyTypeList() {
      return this.getSpecificTranslatedOptions("policyType")
    },
    workflowStepList() {
      return this.getSpecificTranslatedOptions("workFlowStep")
    },
    policyStatusList() {
      return this.getSpecificTranslatedOptions("policyStatus")
    },

  },
  methods: {
    onSortChanged(val) {
      Vue.set(this.sorting, 'orderBy', val.sortBy)
      Vue.set(this.sorting, 'direction', (val.sortDesc) ? 'desc' : 'asc')
    },
    onClickModal(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('GIPolicy/deleteGIPolicy', this.clickedRow.policyID).then((json) => {
        Vue.set(this, 'alertParams', { content: this.$t('osm.contents.general.deleteSuccess'), variant: 'success' });
        this.getDataList();
        this.$refs.alert.showAlert();
        window.scrollTo(0, 0);
      })
    },
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    setSearch(input) {
      this.searchInput.value = input;
      this.getDataList();
    },
    setPerPage(amount) {
      // console.log(amount);
      this.rowsPerPage.value = amount;
      this.pagination.currentPage = 1;
      this.getDataList();
    },
    setCurrentPage(currentPage) {
      // console.log(currentPage);
      this.pagination.currentPage = currentPage;
      this.getDataList();
    },
    getDataList() {
      var params = {
        page: this.pagination.currentPage,
        count: this.rowsPerPage.value
      }
      if (this.searchInput.value.trim().length > 0) {
        params = {
          ...params,
          ...{ search: this.searchInput.value }
        }
      }
      if (this.policyType.value != null) {
        params = {
          ...params,
          ...{ policyType: this.policyType.value }
        }
      }
      if (this.workFlowStep.value != null) {
        params = {
          ...params,
          ...{ workFlowStep: this.workFlowStep.value }
        }
      }
      if (this.policyStatus.value != null) {
        params = {
          ...params,
          ...{ policyStatus: this.policyStatus.value }
        }
      }
      if (this.sorting.orderBy) {
        params = {
          ...params,
          ...{ orderBy: this.sorting.orderBy },
          ...{ direction: this.sorting.direction }
        }
      }
      this.$store.dispatch('GIPolicy/getGIList', params).then((data) => {
        Vue.set(this, 'dataList', data.list);
        Vue.set(this.totalItems, 'total', data.total)
      });
    },
    onClickDropdown(actionType, item) {

      var policyID = item.ID;
      var workFlowStep = item.workFlowStep;
      var policyNumber = item.policyNumber;
      var policyReference = item.policyReference;
      var productChineseName = item.productChineseName;
      var productEnglishName = item.productEnglishName;

      this.$store.commit({ type: 'GIPolicy/setGIPolicyID', policyID: policyID });
      Vue.set(this, 'clickedRow', { policyNumber: policyNumber, policyReference: policyReference, policyID: policyID });
      var wfStep = parseInt(workFlowStep);
      switch (actionType) {
        case 'renewal':
          this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 0);

          this.$router.push({
            name: 'Create GI Policy',
            params: {
              renewalPolicyID: policyID
            }
          });
          break;
        case 'delete':
          this.$refs.modal.openModal();
          break;
        case 'serviceRequest':
          console.debug('lifePolicyList', {
            policy: {
              policyID: policyID,
              policyType: 'P'
            }
          });
          this.$router.push({
            name: 'Select Service Request',
            params: {
              policy: {
                policyID: policyID,
                policyType: 'G'
              }
            }
          })
          break;
        case 'outstanding':
          this.$router.push('/osm/gi/or')
          break;
        case 'claim':
          var policyDetail = {
            policyID: policyID,
            productChineseName: productChineseName,
            productEnglishName: productEnglishName,
            policyType: 'G'
          }
          this.$router.push({
            name: 'Create Claim',
            params: { detail: policyDetail }
          });
          break;
        case 'detail':
          switch (wfStep) {
            case 8:
              this.$store.commit({ type: 'GIPolicy/setIsCompleted', value: true })
              this.$router.push('/osm/gi/detail')
              // this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', wfStep)
              return;
            case 5:
            case 6:
            case 7:
              this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', (wfStep + 1))
              break;
            case 4:
              this.$store.commit({ type: 'GIPolicy/setIsRejected', value: true })
            default:
              this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', wfStep)
              break;
          }
          this.$router.push('/osm/gi/new')
          break;
      }
    },
    createAction(action) {
      this.actions.value.action = action;
      // this.showModal({ rowID: '', action: 'Create' })
    },
    getOptions() {
      this.$store.dispatch('getAllSelections', "gi").then((response) => {
        if (response.status != 200) {
          return;
        }
        Vue.set(this, 'allSelections', response.data);
      }, )
    },
    getSpecificTranslatedOptions(fieldName) {
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      var translatedData = this.getTranslatedOptions(this.$i18n.locale, obj[0].options);
      translatedData.unshift({ value: null, text: this.$t('general.all') });
      return translatedData
    },
    getTranslatedPolicyField(fieldName, key) {
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      var filteredType = obj[0].options.filter((item) => {
        return item.selectionKey === key
      });
      var translatedData = this.getTranslatedOptions(this.$i18n.locale, filteredType);
      if (translatedData.length == 0) {
        return 'N/A'
      }
      return translatedData[0].text
    }

  },
  data() {
    return {
      sorting: {
        sortBy: null,
        sortDesc: null
      },
      clickedRow: {
        policyNumber: -1,
        policyReference: -1,
        policyID: -1
      },
      alertParams: {
        content: '<strong>Success</strong>',
        variant: 'success'
      },
      slots: [
        'policyType'
      ],
      pagination: {
        currentPage: 1,
      },
      searchInput: {
        value: '',
        placeholder: this.$t('general.search')
      },
      rowsPerPage: {
        value: 25,
        options: [10, 25, 50, 100],
        label: this.$t("general.pagination")
      },
      workFlowStep: {
        value: null,
      },
      policyType: {
        value: null,
        key: 'policyType',
        label: 'Policy Type'
      },
      policyStatus: { value: null },
      fields: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.giPolicy.generalInformation.policyNumber'),
          sortable: true
        },
        {
          key: 'policyReference',
          label: this.$t('osm.contents.giPolicy.generalInformation.policyReference'),
          sortable: true
        },
        {
          key: 'policyType',
          label: this.$t('osm.contents.giPolicy.generalInformation.policyType'),
          sortable: true
        },
        {
          key: 'policyOwnerName',
          label: this.$t('osm.contents.giPolicy.generalInformation.policyOwnerName'),
        },
        {
          key: 'currentAgentName',
          label: this.$t('osm.contents.giPolicy.generalInformation.currentAgentName'),
        },
        {
          key: 'workFlowStep',
          label: this.$t('osm.contents.giPolicy.generalInformation.workFlowStep'),
          sortable: true
        },
        {
          key: 'policyStatus',
          label: this.$t('osm.contents.giPolicy.generalInformation.policyStatus'),
          sortable: true
        },
        {
          key: 'approveAgentName',
          label: this.$t('osm.contents.giPolicy.generalInformation.approveAgent'),
        },
        {
          key: 'updateTime',
          label: this.$t('osm.contents.giPolicy.generalInformation.updateTime'),
        },
        {
          key: 'actions',
          label: this.$t('osm.contents.giPolicy.generalInformation.actions')
        }
      ],
      actions: {
        value: { rowID: '', action: '' },
        key: 'actions',
        label: this.$t('osm.contents.giPolicy.generalInformation.actions'),
        options: [
          { text: this.$t('osm.contents.general.detail'), key: 'detail', },
          { text: this.$t('osm.contents.general.renewal'), key: 'renewal', },
          { text: this.$t('osm.contents.general.outstandingRequirement.title'), key: 'outstanding' },
          { text: this.$t('osm.serviceRequest.header'), key: 'serviceRequest' },
          { text: this.$t('osm.claim.apply'), key: 'claim' },
          { text: this.$t('osm.contents.general.delete'), key: 'delete', class: 'text-danger' }
        ]
      },
      totalItems: {
        preFix: this.$t("general.total"),
        postFix: this.$t("general.records"),
        total: 0
      },
      dataList: [],
      allSelections: [],
    }
  },
  watch: {
    sorting: {
      deep: true,
      handler(val) {
        this.getDataList();
      }
    }
  }

}

</script>
<style type="text/css">
.minTableHeight {
  min-height: 300px;
}

</style>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/containers/GIPolicyList.vue